import { Button as AntButton } from "antd"

type Props = {
  label: string
  type?: "primary" | "dashed" | "text" | "link"
  onClick?: () => void
  href?: string
  style?: {}
  icon?: any
  htmlType?: "button" | "submit" | "reset" | undefined
  disabled?: boolean
  loading?: boolean
  download?: string
}

export const Button: React.FC<Props> = ({
  label,
  type,
  onClick,
  href,
  style,
  icon,
  htmlType,
  disabled,
  loading,
  download,
}) => (
  <AntButton
    type={type}
    onClick={onClick}
    href={href}
    style={style}
    icon={icon}
    htmlType={htmlType}
    disabled={disabled}
    loading={loading}
    download={download}
  >
    {label}
  </AntButton>
)
